<template>
  <div :class="clsx(classes, 'relative')" v-if="!isLoading && item" class="file__item">
    <template v-if="showPreview && item.preview && !item.storageId">
      <img :src="item.preview" class="uploading-image my-2" />
    </template>
    <template v-if="showPreview && item.storageId">
      <img :src="BaseURL + item.storageId" class="uploading-image my-2" />
      <video
        v-if="item?.mimetype?.split('/')[0] === 'video'"
        :src="BaseURL + item.storageId"
        controls
        class="post__video my-2"></video>
    </template>
    <div v-show="!showPreview">
      <video
        v-if="item?.mimetype?.split('/')[0] === 'video'"
        :src="BaseURL + item.storageId"
        controls
        class="post__video my-2"></video>
      <video
        v-if="item.type === 'video'"
        :src="item.isEdit ? BaseURL + item.image : item.image"
        controls
        class="post__video my-2"></video>
      <img
        v-if="item.storageId && item?.mimetype?.split('/')[0] !== 'video'"
        :src="BaseURL + item.storageId"
        class="uploading-image my-2" />
      <img
        v-else-if="!item.storageId && item?.mimetype?.split('/')[0] !== 'video' && item.type !== 'video'"
        :src="item.isEdit ? BaseURL + item.image : item.image"
        class="uploading-image my-2" />
    </div>

    <label
      class="text-foregroundPrimary cursor-pointer opacity-60 rounded-[100%] absolute right-4 top-4 bg-[rgba(0,0,0)] w-6 h-6 flex items-center justify-center"
      @click="removeItem">
      <img src="/icon/editor/close.svg" class="w-4" alt="" />
    </label>

    <div class="absolute top-4 left-4 flex items-center gap-1">
      <button v-if="item.type === 'video'" class="p-1 bg-backgroundBtnSecondary rounded-[10px]">
        <label class="file-input-label text-foregroundPrimary cursor-pointer" :for="item.id + '-file-preview'"
          ><img src="/icon/editor/photo.svg" alt="Preview"
        /></label>
        <input :id="item.id + '-file-preview'" class="file-input hidden" type="file" @change="addPreview" />
      </button>
      <button
        v-if="item?.preview"
        @click="showPreview = !showPreview"
        class="p-[8px_12px] bg-backgroundBtnSecondary text-foregroundPrimary text-[11px] rounded-[10px]">
        {{ !showPreview ? 'Show ' : 'Hide ' }} preview
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import clsx from 'clsx';

const props = defineProps({
  item: Object,
  isLoading: Boolean,
  classes: String,
  editData: Boolean,
  BaseURL: String,
});

const showPreview = ref(false);

const emit = defineEmits(['remove', 'addPreview']);

const removeItem = () => {
  emit('remove', props.item.id);
};

const checkedType = item => {
  return item?.mimetype?.split('/')[0] !== 'video';
};

const addPreview = e => {
  const files = e.target.files;
  const file = files?.[0];

  if (!file) {
    return;
  }

  const reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = e => {
    emit('addPreview', {
      ...props.item,
      preview: e.target.result,
      previewFile: file,
    });
  };
};
</script>

<style lang="scss" scoped></style>
